import { render, staticRenderFns } from "./vcTextarea.vue?vue&type=template&id=450e9db8&"
import script from "./vcTextarea.vue?vue&type=script&lang=js&"
export * from "./vcTextarea.vue?vue&type=script&lang=js&"
import style0 from "./vcTextarea.vue?vue&type=style&index=0&id=450e9db8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports